import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

class Quadric extends GeomObject {

    constructor (objectId) {
        super(objectId);
        this.quadricType = null;
        this.lastCoords = [0, 0, 0, 1, 0];
        this.surface_color1 =
            super.getColorAttribute("surface_color1", "#00FFFF");
        this.curve_color1 =
            super.getColorAttribute("curve_color1", "#00FFFF");
        this.curve_radius =
            super.getStyleAttribute("curve_radius", "2");        this.bjsFaces = [];
    }

    quadricTypes = {  0: "undefined",
        1: "cone",
        2: "cylinder",
        3: "subcylinder",
        4: "sphere",
        5: "general",
        6: "one_plane"
    };


updateFromPeer () {
        if (this.objectId === 0) return;
        if (this.quadricType === null) {
            const typeInt = cabri.emsc.getQuadricType(this.objectId);
            if (typeInt === 0) return;
            this.quadricType = this.quadricTypes[typeInt];
        }
    let coords;
        try {
            if (this.quadricType === "sphere") {
                coords = cabri.emsc.getSphereCenterAndRadius(this.objectId);
                let c = this.lastCoords;
                if (this.forceUpdateInNextCycle || coords[0] !== c[0] ||
                    coords[1] !== c[1] || coords[2] !== c[2] ||
                    coords[3] !== c[3] || coords[4] !== c[4]) {
                    this.forceUpdateInNextCycle = false;
                    let newCoords = [coords[0], coords[1], coords[2], coords[3],
                                     coords[4]];
                    this.updateSphere(newCoords);
                    for (let i = 0; i < 5; i++) c[i] = newCoords[i];
                    return true;
                }
                else {
                    return false;
                }
            } else if (this.quadricType === "cylinder" || this.quadricType === "cone" || this.quadricType === "subcylinder") {
                try{ cabri.emsc._free(coords);} catch(e){}
                coords = cabri.emsc.renderAsMeshConic(this.objectId,2,false);
                let c= this.lastCoords,
                    changed = this.forceUpdateInNextCycle || coords.length !== c.length+1;
                for(let i=0, l=c.length; i<l && !changed; i++) {
                    changed = (Math.abs(c[i]-coords[i])>0.000000001);
                }
                if(changed)  {
                    this.forceUpdateInNextCycle = false;
                    this.createConicSurface(coords);
                }

            }
        } catch (e) {
            console.log(
                "Trouble at updateFromPeer (" + this.constructor.name +
                ").");
            console.log(e);
        } finally {
            if (coords)
                try {
                    cabri.emsc._free(coords);
                } catch (e) {
                }
        }
    }

    updateSphere (newCoords) {
        if (this.bsphere) { //  && newCoords[4]) {
            this.bsphere.scaling.x = this.bsphere.scaling.y = this.bsphere.scaling.z = newCoords[4]
            this.bsphere.position = this.getPosition(newCoords);
        }
        else
            this.createSphere(newCoords)

        /*    if (this.bsphere && newCoords[4] === this.lastCoords[4])
                this.bsphere.position = this.getPosition(newCoords);
            else {
                if (this.bsphere)
                    this.bsphere.dispose();
                this.createSphere(newCoords);
            }
        }*/
    }

    createSphere (newCoords) {
        if (this.noDisplay || this.hidden) return;
        this.bsphere =
            BABYLON.MeshBuilder.CreateSphere("quadric" + this.objectId,
                {
                    diameter: 2,  // * this.getRadius(newCoords),        // radius 1
                    segments: 32,
                },
                // TODO: dynamically compute depending on radius and projection
                // ratio from point
                cabri.scene);
        //let radius = this.getRadius(newCoords)
        this.bsphere.scaling. x = this.bsphere.scaling. y = this.bsphere.scaling. z = newCoords[4]
        this.bsphere.cabriPeer = this;
        this.bsphere.position = this.getPosition(newCoords);

        super.markColor(this.bsphere, this.surface_color1);
        //this.bsphere.material.alpha = 0.8;
        this.bsphere.visibility = 0.8;
        //super.registerHighlighter(this.bsphere,
        //    new BABYLON.Color3(0.4, 0.1, 0.1));
    }

    getRadius (c) {
        return c[4];
    }

    getPosition (c) {
        return new BABYLON.Vector3(c[0]/c[3], c[2]/c[3], c[1]/c[3]);
    }

    createConicSurface(coords) {
        if(coords[coords.length-1]!==0) throw "I don't expect a breakage!";
        const l = (coords.length-1)/6, c = this.lastCoords = new Array(l*6);
        for(let i=0; i<l; i++) c[i] = coords[i];
        
        if(this.bjsFaces) for(let t of this.bjsFaces) if(t) t.dispose(false, true);

        const bjsFaces = this.bjsFaces = new Array(l);
        for(let i=0; i<l; i++) {
            const a = new BABYLON.Vector3(c[i*2], c[i*2+2], c[i*2+1]),
                b =new BABYLON.Vector3(c[i*2+3], c[i*2+5], c[i*2+4]);
            // for now create tubes to understand the behaviour (I was expecting two rings for the sample cylinder)
            bjsFaces[i] = BABYLON.MeshBuilder.CreateTube("quadricSurface" + this.objectId,
                {path: [a,b], radius: 0.05}, cabri.scene);
            super.markColor(bjsFaces[i], this.surface_color1);
        }

        if(this.bjsSegments) for(let s of this.bjsSegments) if(s) s.dispose(false, true);
        const coords1 = cabri.emsc.renderAsMeshConic(this.objectId, 1, false);
        const numBreakages = Math.floor(coords1[coords1.length-1]), breakages = new Array(numBreakages+1),
            numCoords = coords1.length-1-numBreakages;
        for(let i=0; i<numBreakages; i++) breakages[i] = Math.floor(coords1[numCoords+i]);
        breakages[numBreakages] = numCoords;
        const bjsSegments = this.bjsSegments = new Array(numCoords/3);
        let numCoord = 0, numSeg = 0;
        while(numCoord<numCoords) {
            const numSubsegments = breakages[numSeg] - numCoord,
                path = new Array(numSubsegments);
            for(let i=0; i<numSubsegments; i++) {
                path[i] = new BABYLON.Vector3(coords1[numCoord], coords1[numCoord+2], coords1[numCoord+1]);
                numCoord++;
            }

            bjsSegments[numSeg] = BABYLON.MeshBuilder.CreateTube("quadricBorder", {
                path: path, radius: this.curve_radius*0.05, updatable: true});
            super.markColor(bjsSegments[numSeg], this.curve_color1);
        }
    }
}

export {Quadric};